import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { clsx } from 'clsx';
import { generateDataTestId } from '../../../internal/utils';
import { hasCounter } from './utils';
import { Counter } from '../../../internal/components/Counter';
import * as styles from './ChipButton.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ChipButton = function ChipButton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'M' : _ref$size,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'right' : _ref$iconPosition,
    counter = _ref.counter,
    counterMaxLength = _ref.counterMaxLength,
    checked = _ref.checked,
    invalid = _ref.invalid,
    disabled = _ref.disabled,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    dataTestId = _ref.dataTestId,
    text = _ref.text,
    onClick = _ref.onClick;
  var chipRef = React.useRef(null);
  var handleClick = function handleClick(event) {
    var _chipRef$current;
    onClick(!checked, event);
    (_chipRef$current = chipRef.current) === null || _chipRef$current === void 0 || _chipRef$current.blur();
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.code === 'Space') {
      onClick(!checked);
    }
  };
  var counterExists = hasCounter(counter);
  var disableButton = disabled || counter === 0;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['chip-button'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['chip-button--checked'], checked), styles['chip-button--disabled'], disableButton), styles['chip-button--invalid'], invalid), styles['chip-button--only-icon'], !text && icon), styles['chip-button--small'], size === 'S'), styles['chip-button--medium'], size === 'M')),
    onClick: handleClick,
    "data-testid": dataTestId,
    tabIndex: disableButton ? -1 : tabIndex,
    onKeyDown: handleKeyDown,
    ref: chipRef,
    role: "button",
    children: [text && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      "data-testid": generateDataTestId(dataTestId, ['text']),
      children: text
    }), icon && !counterExists && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['icon'], _defineProperty({}, styles['icon--left'], iconPosition === 'left')),
      "data-testid": generateDataTestId(dataTestId, ['icon']),
      children: icon
    }), counterExists && /*#__PURE__*/_jsx(Counter, {
      counter: counter,
      counterMaxLength: counterMaxLength,
      dataTestId: generateDataTestId(dataTestId, ['counter'])
    })]
  });
};